import styled from 'styled-components';
import { Table } from 'antd';

const StyledTable = styled(Table)``;

export { StyledTable };
